import React from "react";
import { TourHighlightsSection } from "@/types/dto/destinations-page/destination-page-types";
import { Box } from "@mui/material";
import TourHighlightsCarousel from "@/components/destinations-page/tour-highlights-section/tour-highlights-carousel";

interface TourHighlightsSectionProps {
  tourHighlightsSection: TourHighlightsSection;
  moduleRankingPosition?: string;
}

const TourHighlightsSectionComponent: React.FC<TourHighlightsSectionProps> = ({ tourHighlightsSection, moduleRankingPosition="6" }) => (
  <Box 
    className="fluid-box anchor-section" 
    sx={{ backgroundColor: "primary.main" }} 
    id="destination-tours"
    data-track="visibility"
    data-parent-container-type="carousel"
    data-module-name="Tour Highlight Section"
    data-ranking-algorithm="manual"
    data-module-ranking="custom_sort"
    data-module-ranking-position={moduleRankingPosition}
    component="section"
  >
    <Box
      className="destination-page-container"
      data-testid="tour-highlights-container"
      sx={{
        padding: {
          xs: "2.4rem 2.4rem",
          md: "6rem clamp(2.4rem, 4.5vw, 6.5rem)"
        }
      }}
    >
      <TourHighlightsCarousel tours={tourHighlightsSection.tours} />
    </Box>
  </Box>
);

export default TourHighlightsSectionComponent;